import { Auth, AuthAction, AuthActionType, defaultAuth } from './types';

export function authReducer(state: Auth = defaultAuth, action: AuthAction): Auth {
    switch (action.type) {
        case AuthActionType.REQUEST_AUTH:
            return {
                ...state,
                isLoading: true,
                isValidating: false,
            };

        case AuthActionType.REQUEST_AUTH_VALIDATE:
            return {
                ...state,
                isLoading: true,
                isValidating: true,
            };

        case AuthActionType.RECEIVE_AUTH_LOGIN:
            if (action.payload?.success) {
                // Successful sign in, save user data and token
                return {
                    isAuthenticated: action.payload?.auth?.isAuthenticated,
                    isLoading: false,
                    nr: action.payload?.auth.nr,
                    mail: action.payload?.auth.mail,
                    name: action.payload?.auth.name,
                    kz: action.payload?.auth.kz,
                    rolle: action.payload?.auth.rolle,
                };
            }

            // Unsuccessful sign in, save error
            return {
                ...state,
                isAuthenticated: false,
                isLoading: false,
                isValidating: false,
                error: action.payload?.auth?.error,
            };

        case AuthActionType.RECEIVE_AUTH_LOGOUT:
            if (action.payload?.auth?.error) {
                return {
                    ...state,
                    error: action.payload?.auth?.error,
                };
            }
            return {
                ...state,
                isAuthenticated: false,
                isLoading: false,
                isValidating: false,
                error: '',
            };

        case AuthActionType.RECEIVE_AUTH_CHANGE_PASSWORD:
            if (action.payload?.auth?.error) {
                return {
                    ...state,
                    isLoading: false,
                    isValidating: false,
                    error: action.payload?.auth?.error,
                };
            }
            return {
                ...state,
                isLoading: false,
                isValidating: false,
                mail: state.mail,
                message: 'Password changed successfully, please sign in again',
            };

        default:
            return state;
    }
}
